import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

const PaginationTotal = ({clang, totalPages, currentPage, setPageByNum}) => {
    return (
        <div className="pagination__total">
            <span className="pagination__total-label">
                {lang[clang].pagination.from}
            </span>
            <button className={`pagination__button ${currentPage === totalPages ? 'disabled' : ''}`}
                    onClick={() => setPageByNum(totalPages)}>
                {totalPages}
            </button>
        </div>
    );
};

PaginationTotal.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(PaginationTotal);



// WEBPACK FOOTER //
// ./src/components/pagination/PaginationTotal.js